export default {
  accountTags: (state) => state.accountTags,
  accountTagsLoading: (state) => state.accountTagsLoading
}
